import getBasePath from '../../../../common/functions/api-resource';

export const basePath = getBasePath('job', '/exportacao-evidencias');

const geracaoExportacaoActions = {
  gerarExportacao: { method: 'POST', url: `${basePath}` },
};

export default resource => resource(`${basePath}`, {}, geracaoExportacaoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/geracao-exportacao.js